import { FC } from 'react';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import { Price } from '#advertDetail/components/price-list/Price';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import modelDetailParameterListCss from '../../assets/model-detail/model-detail-parameter-list.module.scss';

const PriceList: FC = () => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      priceDataList,
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return null;
  }

  if (priceDataList.length === 0) {
    return null;
  }

  const priceElementList = priceDataList.map((priceData) => (
    <Price key={priceData.type} price={priceData.value} type={priceData.type} />
  ));

  return (
    <div className={modelDetailParameterListCss.modelDetailParameterList}>
      {priceElementList}
    </div>
  );
};

export { PriceList };
